// extracted by mini-css-extract-plugin
export const faq = "faq-module--faq--2a8n7";
export const faqItem = "faq-module--faq-item--1Nnxd";